import gql from 'graphql-tag';

const query = gql`
  query Tests($filter: HashimotoTestFieldEnum) {
    hashimoto {
      hashimotoTestHistory(hashimotoTestField: $filter) {
        edges {
          node {
            id
            tsh
            ft3
            ft4
            antiTg
            antiTpo
            testedAt
            __typename
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
      }
    }
  }
`;

export default query;
